export enum OrderState {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Canceled = 'CANCELED',
  LockedCheckout = 'LOCKED_CHECKOUT',
  LockedChangeLocation = 'LOCKED_CHANGE_LOCATION',
}
